import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { site } from "@/config/site";

export default function Access() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main className="pt-24 md:pt-28 pb-16">
        {/* ページタイトル */}
        <div className="bg-background-100 border-b border-background-200">
          <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14 text-center">
            <p className="inline-flex items-center gap-2 text-xs md:text-sm font-bold text-primary-700 bg-primary-100 rounded-full px-4 py-1.5 mb-4">
              <i className="ri-map-pin-line"></i>
              アクセス
            </p>
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              アクセス
            </h1>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 md:px-6 mt-10">
          {/* 会社情報 */}
          <div className="bg-background-100 rounded-lg border border-background-200 p-6 md:p-8">
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-5">
              株式会社MEGURI
            </h2>
            <dl className="space-y-4 text-sm md:text-base">
              <div className="flex gap-3">
                <dt className="shrink-0 w-20 font-bold text-foreground-700">住所</dt>
                <dd className="text-foreground-700">{site.address}</dd>
              </div>
              <div className="flex gap-3">
                <dt className="shrink-0 w-20 font-bold text-foreground-700">電話番号</dt>
                <dd className="text-foreground-700">
                  <a href={`tel:${site.phone}`} className="hover:text-primary-700 transition-colors">
                    {site.phone}
                  </a>
                </dd>
              </div>
              <div className="flex gap-3">
                <dt className="shrink-0 w-20 font-bold text-foreground-700">定休日</dt>
                <dd className="text-foreground-700">{site.holiday}</dd>
              </div>
            </dl>
          </div>

          {/* Googleマップ */}
          <div className="mt-6 rounded-lg overflow-hidden border border-background-200">
            <iframe
              title="株式会社MEGURI 所在地マップ"
              src="https://www.google.com/maps?q=%E9%95%B7%E5%B4%8E%E7%9C%8C%E4%BD%90%E4%B8%96%E4%BF%9D%E5%B8%82%E6%97%A5%E5%AE%87%E7%94%BA1094-1&output=embed"
              className="w-full h-[360px] md:h-[480px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* ご来訪について */}
          <div className="mt-6 bg-background-100 rounded-lg border border-background-200 p-6 md:p-8">
            <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-3 flex items-center gap-2">
              <i className="ri-information-line text-accent-700"></i>
              ご来訪について
            </h3>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              ご来訪の際は、事前に公式LINEよりお問い合わせください。
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}